export const SMART_GROUP_EDIT_DISABLED_REASON =
  "This Smart Group contains auto-grouped TikTok target collaborations and cannot be edited at group level. To make changes, edit individual collaborations.";
